<template>
  <div class="core d-flex align-center justify-center">
    <div class="content d-flex f-column align-center">
      <h3>区块链技术支持核心</h3>
      <p>利用区块链、大数据、物联网技术，建设生猪产业链智慧大脑。</p>
      <p>为各个环节提供实时、准确、安全的生猪溯源信息。</p>
      <div class="list d-flex">
        <div class="item d-flex f-column align-center justify-center">
          <el-image
            class="image"
            :src="require('@/assets/images/core_01.png')"
          ></el-image>
          <div class="title">智脑核心</div>
          <span class="desc"
            >生猪智脑是全产业链平台的 大脑中枢，及数据采集、计算、学习、服务4位一体</span
          >
        </div>
        <div class="item d-flex f-column align-center justify-center">
          <el-image
            class="image"
            :src="require('@/assets/images/core_02.png')"
          ></el-image>
          <div class="title">集控安全</div>
          <span class="desc"
            >全链路使用特定网关私有线路传输自建模型算法加密，大数据线上线下分块存储</span
          >
        </div>
        <div class="item d-flex f-column align-center justify-center">
          <el-image
            class="image"
            :src="require('@/assets/images/core_03.png')"
          ></el-image>
          <div class="title">溯源防篡改</div>
          <span class="desc"
            >各个环节生成带有时间戳的数据账本，模型算法加密。 唯一溯源码，永久存活。
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.core {
  .content {
    h3 {
      padding: 1.25rem 0 0.375rem;
      font-size: 0.375rem;
    }
    p {
      line-height: 0.375rem;
      font-size: 0.2rem;
      color: #666;
    }
    .list {
      padding: 0.825rem 0 1.25rem;
      .item {
        width: 4.8125rem;
        height: 5.25rem;
        background-color: #f9fafe;
        margin-right: 0.275rem;
        &:last-of-type {
          margin-right: 0;
        }
        .image {
          display: block;
          width: 2.275rem;
          height: 2.275rem;
        }
        .title {
          font-weight: 600;
          font-size: 0.25rem;
          color: #666;
          padding: 0.45rem 0 0.3rem;
        }
        .desc {
          padding: 0 0.925rem;
          line-height: 0.3rem;
          text-align: center;
          font-size: 0.175rem;
          color: #999;
        }
      }
    }
  }
}
</style>
